// frontend/src/api/axiosInstance.js
import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "https://apigw.rtaf.mi.th/login-rtaf-mfa/v2/mfa/login",
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");

    // console.log("➡️ API REQUEST:", {
    //   url: config.url,
    //   method: config.method,
    //   token,
    // });

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error),
);

/**
 * ============================
 * RESPONSE INTERCEPTOR
 * ดัก token หมดอายุ / 401 
 * (รวบเป็นชุดเดียวเพื่อป้องกันสิทธิ์การแย่งกันทำงาน)
 * ============================
 */
api.interceptors.response.use(
  (response) => {
    // console.log("✅ API RESPONSE:", response.config.url, response.status);
    return response;
  },
  (error) => {
    const status = error?.response?.status;
    const url = error?.config?.url || "";

    // console.error("❌ API ERROR:", status, error?.response?.data);

    // 🔒 รวมเงื่อนไขยกเว้นสำหรับหน้า Login ปกติ และหน้าตรวจสอบ OTP ไว้ด้วยกันอย่างปลอดภัย
    const isLoginRequest = url.includes("/api/member/login") || url.includes("login-otp");

    // Token หมดอายุ หรือไม่ถูกต้อง และต้องไม่ใช่ Request ที่เกิดจากหน้าล็อกอิน
    if (status === 401 && !isLoginRequest) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      window.location.href = "/login";
    }

    return Promise.reject(error);
  },
);

export default api;